export function getUrl(){
  return 'http://localhost:9094/wujinWeb'
}

export function getTokenInfo(){
  return 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsImV4cCI6MTYyODA3Mjc5NSwiaWF0IjoxNTk2NTM2Nzk1fQ.YpGCYmQwgOwxfpA12ke-uG0tlRT0pZ5ItMV1X7hcrqJS4zewft2baI6KsBgw5L3BMHmKy6rhwrTzqwCS5l2bfQ'
}

export function getImagePathService(id){
  return custemRequest({
    url: 'upload/pathaj/'+id
  })
}



// WEBPACK FOOTER //
// ./src/util/CommonApi.js